import { AccountGotoAction } from '../account-router';
import { DisabledReason } from './model/disabled-reason';

export class FetchDisabledDetails {
  static readonly type = '[DisabledDetails] Fetch details of disabled session';
}

export class ReactivateAccount {
  static readonly type = '[DisabledDetails] Reactivate account';
}

export class MarkAccountForDeletion {
  static readonly type = '[DisabledDetails] Mark account for deletion';
  constructor(public reason: DisabledReason = 'outdatedTerms') {}
}

export class GotoAcceptNewTerms extends AccountGotoAction {
  static readonly type = '[DisabledDetails] Goto accept terms';
}

export class GotoDeactivatedAccount extends AccountGotoAction {
  static readonly type = '[DisabledDetails] Goto deactivated account';
}

export class GotoReactivateAccount extends AccountGotoAction {
  static readonly type = '[DisabledDetails] Goto reactivate account';
}
